/* global getLang */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import * as moment from 'moment'
import locale from 'element-ui/lib/locale'
import router from './router'

Vue.use(VueI18n)

const getMappedId = (locale, map) => {
  return map[locale] || locale
}

const vueI18nMap = {
  zh: 'zh-CN',
  tw: 'zh_TW'
}

const elementUIMap = {
  zh: 'zh-CN',
  tw: 'zh-TW'
}

// const momentMap = {
//   zh: 'zh-cn',
//   tw: 'zh-tw'
// }

const lang = getLang()

const i18n = new VueI18n({
  locale: ''
})

const setI18nLanguage = (lang) => {
  i18n.locale = lang
  document.documentElement.setAttribute('lang', lang)
  return lang
}

const loadedLanguages = []
const loadLanguageAsync = (lang) => {
  const vueI18Lang = getMappedId(lang, vueI18nMap)
  console.log(vueI18Lang)
  if (i18n.locale !== vueI18Lang) {
    if (!loadedLanguages.includes(lang)) {
      const elementUILang = getMappedId(lang, elementUIMap)
      // const momentLang = getMappedId(lang, momentMap)
      return Promise.all([
        import(/* webpackChunkName: "lang-[request]" */ `common/lang/${lang}.json`),
        import(/* webpackChunkName: "lang-[request]" */ `common/lang/${lang}part.json`),
        import(/* webpackChunkName: "lang-[request]" */ `element-ui/lib/locale/lang/${elementUILang}`)
        // import(/* webpackChunkName: "lang-[request]" */ `moment/locale/${momentLang}`)
      ]).then(([msg1, msg2, elementMsg]) => {
        const msg = Object.assign({}, msg1, msg2)
        i18n.setLocaleMessage(vueI18Lang, msg)
        locale.use(elementMsg.default)
        // moment.locale(momentLang)
        loadedLanguages.push(lang)
        return setI18nLanguage(vueI18Lang)
      })
    }
    return Promise.resolve(setI18nLanguage(vueI18Lang))
  }
  return Promise.resolve(vueI18Lang)
}

const promise = loadLanguageAsync(lang)
router.beforeEach((to, from, next) => {
  promise.then(() => {
    document.title = i18n.t(to.meta.title)
    next()
  })
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js